export default __webpack_public_path__ + "static/media/gallery_06.e2cb2779.jpg";